import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, isObservable, of } from 'rxjs';

interface ButtonToggleOption {
  value: any;
  label: string;
}

interface ButtonToggleProps extends FormlyFieldProps {
  options: ButtonToggleOption[] | Observable<ButtonToggleOption[]>;
}

@Component({
  selector: 'app-formly-mat-button-toggle',
  template: `
    <mat-button-toggle-group
      [id]="id"
      [disabled]="props.disabled"
      [value]="formControl.value"
      (change)="formControl.setValue($event.value)"
      appearance="standard"
    >
      @for (option of options$ | async; track option) {
        <mat-button-toggle [value]="option.value">
          {{ option.label | translate }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
    @if (showError) {
      <div>{{ props.description }}</div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonToggleModule, TranslatePipe, AsyncPipe],
})
export class FormlyMatButtonToggleComponent
  extends FieldType<FieldTypeConfig<ButtonToggleProps>>
  implements OnInit
{
  options$: Observable<ButtonToggleOption[]> = of([]);

  ngOnInit() {
    const opts = this.props.options;
    this.options$ = isObservable(opts) ? opts : of(opts ?? []);
  }
}
